export class PatientCashDeskSeachItem {
  public HasCreditNote: boolean;
  public IsCreditNote: boolean;
  public Protocol: string;
  public Practice: string;
  public PatientFullName: string;
  public MedicalAppointmentId: number;
  public MedicalOrderAmount: number;
  public MedicalAppointmentDate: string;
  public CashDeskStateId: number;
  public CashDeskStateDescription: string;
  public CashDeskInvoiceId?: number;
  public OriginaInvoiceId?: number;
  public InvoiceTypeDescription: string;
  public InvoiceTypeId: number;
  public InvoiceCreateDate: string;
  public InvoiceAmount: number;
  public InvoiceNumber: string;
}
